import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增应急反馈
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyFeedback/save',
        method: 'post',
        data
    })
}
//修改应急反馈
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyFeedback/update',
        method: 'post',
        data
    })
}
//查询应急反馈列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyFeedback/list',
        method: 'get',
        params
    })
}
//查询应急反馈
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyFeedback/detail?id=' + id,
        method: 'get',
    })
}
//删除应急反馈
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyFeedback/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}